// UTM Parameter Preservation Script
// This script ensures UTM parameters are preserved during variant changes and other URL updates

(function() {
  'use strict';
  
  // Store original UTM parameters when page loads
  let originalUTMParams = '';
  
  function extractUTMParams(url) {
    const urlObj = new URL(url);
    const searchParams = new URLSearchParams(urlObj.search);
    const utmParams = new URLSearchParams();
    
    // Extract all UTM parameters
    for (const [key, value] of searchParams) {
      if (key.startsWith('utm_') || key.startsWith('UTM_')) {
        utmParams.append(key, value);
      }
    }
    
    return utmParams.toString();
  }
  
  function preserveUTMInURL(newUrl) {
    if (!originalUTMParams) return newUrl;
    
    const urlObj = new URL(newUrl, window.location.origin);
    const existingParams = new URLSearchParams(urlObj.search);
    const utmParams = new URLSearchParams(originalUTMParams);
    
    // Add UTM parameters to the new URL
    for (const [key, value] of utmParams) {
      existingParams.set(key, value);
    }
    
    urlObj.search = existingParams.toString();
    return urlObj.toString();
  }
  
  // Initialize UTM parameters on page load
  function init() {
    originalUTMParams = extractUTMParams(window.location.href);
    
    // Override history.replaceState to preserve UTM parameters
    const originalReplaceState = history.replaceState;
    history.replaceState = function(state, title, url) {
      if (url && originalUTMParams) {
        url = preserveUTMInURL(url);
      }
      return originalReplaceState.call(this, state, title, url);
    };
    
    // Override history.pushState to preserve UTM parameters
    const originalPushState = history.pushState;
    history.pushState = function(state, title, url) {
      if (url && originalUTMParams) {
        url = preserveUTMInURL(url);
      }
      return originalPushState.call(this, state, title, url);
    };
    
    // Monitor for variant changes specifically
    document.addEventListener('variant:changed', function(e) {
      setTimeout(function() {
        const currentUrl = window.location.href;
        if (originalUTMParams && !currentUrl.includes('utm_')) {
          const newUrl = preserveUTMInURL(currentUrl);
          if (newUrl !== currentUrl) {
            originalReplaceState.call(history, {path: newUrl}, '', newUrl);
          }
        }
      }, 100);
    });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(); 